import React from 'react';
import PropTypes from 'prop-types';
import {loginUiTexts} from 'data/ui-texts';
import {getText} from 'helpers/language-helper';
import Button from 'components/button/button';
import GroupPlayers from 'components/group-players/group-players';
import './login-group.scss';

const LoginGroup = (props) => {
	const {
		isLoading,
		languageId,
		handleInput,
		handleFindGame,
		handleJoinGame,
		code,
		groups,
		companyData,
		feedback
	} = props;

	/* Group login part 2: select group */
	if (groups) {
		return (
			<div className="LoginGroup-loginChooseGroup">
				<div className="LoginGroup-loginChooseGroupWrapper">
					{isLoading ?
						<div className="LoginGroup-loadingWrapper" /> :
						groups.map((group)=>{
							return (
								<div 
									key={group.id} 
									className={'LoginGroup-groupSelectBtn'}
									onClick={() => {handleJoinGame(group.id);}}
								>
									<div className="LoginGroup-groupSelectTitle">{group.title}</div>
									<div className="LoginGroup-groupSelectPlayers">
										<GroupPlayers group={group} companyData={companyData} type="login" />
									</div>
								</div>
							);
						})
					}
				</div>
			</div>
		);
	}

	/* Group login part 1: enter game code */

	return (
		<div className="LoginGroup">
			{isLoading ?
				<div className="LoginGroup-loadingWrapper"></div> :
				<form className="LoginGroup-form" onSubmit={handleFindGame}>
					<input
						name="code"
						placeholder={getText(loginUiTexts.gameCode, languageId)} 
						autoComplete="section-grouplogin code"
						value={code ? code : ''}
						onChange={(event)=>{handleInput(event);}}
					/>
					<div className="LoginGroup-errorMessage">{feedback}</div>
					<Button 
						text={getText(loginUiTexts.login, languageId)} 
						classes={['login']} onClick={handleFindGame} 
					/>
				</form>
			}
		</div>
	);

};

LoginGroup.propTypes = {
	isLoading: PropTypes.bool,
	languageId: PropTypes.string.isRequired,
	handleInput: PropTypes.func.isRequired,
	handleFindGame: PropTypes.func.isRequired,
	handleJoinGame: PropTypes.func.isRequired,
	code: PropTypes.any,
	groups: PropTypes.any,
	companyData: PropTypes.object,
	feedback: PropTypes.string
};

export default LoginGroup;